import React, { Component } from 'react';
import Axios from '../../webservice/service';
import Order from './Order/Order';
import Spinner from '../../stateless/common/Spinner/Spinner';
import {connect} from 'react-redux';
import NotifyWrapper from '../../wrapper/NotifyWrapper';

class Orders extends Component{

    state = {
        orders : [],
        loading : false
    }

    componentDidMount(){
        this.setState({loading:true});
        Axios.get('/order.json?auth=' + this.props.token).then(response => {
            let keys = [];
            for (const key in response.data) {
                    keys.push({
                        ...response.data[key],
                        id : key
                    });
            }
            this.setState({orders:keys,loading:false});
        }).catch(error => {
            this.setState({loading:false});
        })
    }

    render(){
        let Loading = null;
        if(this.state.loading){
            Loading = <Spinner/>
        }else if (this.state.orders.length > 1){
            Loading = this.state.orders.map(orders => {
                return <Order key={orders.id} ingredients={orders.ingredients}></Order>
            });
        }
        return (
            <div>
                {Loading}
            </div>
        );
    }
}

const linkState = (state) => {
    return {
        ...state.AuthReducer
    }
}

export default connect(linkState)(NotifyWrapper(Orders,Axios));